import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import FetchModule from '../../Model/Share/Network/FetchModule';
import LocalStorage from '../../Model/Share/Network/LocalStorage';
import { useLanguage } from '../../Context/LanguageContext';
import { callingCodeToCountry } from '../../Utils/phoneUtils';

import MainAccountInfoCard from './MainAccountInfoCard';
import MainAccountLinkoPayCard from './MainAccountLinkoPayCard';
import MainPhoneEditModal from './MainPhoneEditModal';
import MainPasswordEditModal from './MainPasswordEditModal';
import MainSecondPasswordEditModal from './MainSecondPasswordEditModal';
import LinkoPayApplyModal from './LinkoPayApplyModal';

export default function MainAccountContent(props) {
  const {
    id,
    email,
    ownerName,
    ownerProfile,
    phone,
    phoneCountryCode,
    setPhone,
    setPhoneCountryCode,
    passwordModifiedAt,
    secondPasswordModifiedAt,
    refetchAccount,
    linkopayProps
  } = props;

  const history = useHistory();
  const { t } = useLanguage();

  const linkopay = linkopayProps || {};

  const [isPhoneModalOpen, setIsPhoneModalOpen] = useState(false);
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const [isSecondPasswordModalOpen, setIsSecondPasswordModalOpen] = useState(false);
  const [linkoPayModalMode, setLinkoPayModalMode] = useState(null);

  function onClickEditPhone() {
    setIsPhoneModalOpen(true);
  }

  // 휴대전화 번호 저장 - 기존 account/info/modify 엔드포인트 사용 (SMS 인증 미연동) //
  function onClickSavePhone(countryCode, newPhone) {

    if (!newPhone || newPhone === '') {
      alert(t('myStoreSetting.alert.phoneRequired'));
      return;
    }

    const requestData = {
      ownerName: ownerName,
      phone: newPhone,
      country_code: countryCode,
      country_iso: callingCodeToCountry[countryCode]
    };

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('account/info/modify', 'POST', requestData);

        if (responseData.status === 200) {
          setPhone(newPhone);
          setPhoneCountryCode(countryCode);
          setIsPhoneModalOpen(false);
          alert(t('myStoreSetting.alert.phoneChangeSuccess'));
        }
        else if (responseData.status === 401) {
          history.push('/login');
        }
        else {
          alert(t('myStoreSetting.alert.serverError'));
        }
      }
    )();
  }

  function onClickEditPassword() {
    setIsPasswordModalOpen(true);
  }

  // 비밀번호 변경 - 성공 시 세션 초기화 후 로그인 페이지로 //
  function onClickSavePassword(currentPassword, newPassword) {
    const requestData = {
      nowPassword: currentPassword,
      willChangePassword: newPassword,
    };

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('account/change/password', 'POST', requestData);

        if (responseData.status === 200) {
          alert(t('myStoreSetting.account.passwordEditModal.successAlert'));
          LocalStorage.clearAll();
          history.push('/login');
        }
        else if (responseData.status === 201) {
          alert(t('myStoreSetting.account.passwordEditModal.currentIncorrectAlert'));
        }
        else if (responseData.status === 401) {
          history.push('/login');
        }
        else {
          alert(t('myStoreSetting.alert.serverError'));
        }
      }
    )();
  }

  function onClickEditSecondPassword() {
    setIsSecondPasswordModalOpen(true);
  }

  // 2차 비밀번호 변경 - 성공 시 세션 유지하고 모달만 닫음 //
  function onClickSaveSecondPassword(currentPin, newPin) {
    const requestData = {
      prevSecondPw: currentPin,
      newSecondPw: newPin
    };

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postData('second_auth/change', 'POST', requestData);

        if (responseData.status === 200) {
          alert(t('myStoreSetting.account.secondPasswordEditModal.successAlert'));
          setIsSecondPasswordModalOpen(false);
          if (refetchAccount) refetchAccount();
        }
        else if (responseData.status === 201) {
          alert(t('myStoreSetting.account.secondPasswordEditModal.currentIncorrectAlert'));
        }
        else if (responseData.status === 401) {
          history.push('/login');
        }
        else {
          alert(t('myStoreSetting.alert.serverError'));
        }
      }
    )();
  }

  // 링코페이 미가입 상태에서 심사요청 클릭 - 신청 모드로 모달 오픈 //
  function onClickLinkoPayApply() {
    setLinkoPayModalMode('apply');
  }

  // 링코페이 가입 상태에서 수정하기 클릭 - 카드에서 계산된 mode(reviewing/active/rejected)로 모달 오픈 //
  function onClickLinkoPayModify(mode) {
    setLinkoPayModalMode(mode);
  }

  // 심사 요청 성공 후 상위 상태 갱신 - 응답 DTO로 카드 표시 갱신 후 모달 종료 //
  function onClickLinkoPayApplySubmit(submittedData) {
    if (submittedData) {
      if (linkopay.setData) linkopay.setData(submittedData);
      if (linkopay.setBusinessRegistrationNumber) linkopay.setBusinessRegistrationNumber(submittedData.businessRegistrationNumber || '');
      if (linkopay.setRepresentativeName) linkopay.setRepresentativeName(submittedData.representativeName || '');
      if (linkopay.setEmail) linkopay.setEmail(submittedData.email || '');
      if (linkopay.setBankCode) linkopay.setBankCode(submittedData.bankCode || '');
      if (linkopay.setBankName) linkopay.setBankName(submittedData.bankName || '');
      if (linkopay.setAccountNumber) linkopay.setAccountNumber(submittedData.accountNumber || '');
      if (linkopay.setSettleCycle) linkopay.setSettleCycle(submittedData.settlementCycle);
      if (linkopay.setSettleCycleUnit) linkopay.setSettleCycleUnit(submittedData.settlementCycleUnit || '');
      if (linkopay.setStoreName) linkopay.setStoreName(submittedData.storeName || '');
      if (linkopay.setBusinessLicenseUrl) linkopay.setBusinessLicenseUrl(submittedData.businessLicenseUrl || '');
      if (linkopay.setBusinessLicenseFileName) linkopay.setBusinessLicenseFileName(submittedData.businessLicenseFileName || '');
      if (linkopay.setPhone) linkopay.setPhone(submittedData.phone || '');
      if (linkopay.setHolderName) linkopay.setHolderName(submittedData.holderName || '');
    }

    setLinkoPayModalMode(null);
  }

  return (
    <TopLevelWrapper>
      <MainAccountInfoCard
        id={id}
        email={email}
        ownerName={ownerName}
        ownerProfile={ownerProfile}
        phone={phone}
        phoneCountryCode={phoneCountryCode}
        passwordModifiedAt={passwordModifiedAt}
        secondPasswordModifiedAt={secondPasswordModifiedAt}
        onClickEditPhone={onClickEditPhone}
        onClickEditPassword={onClickEditPassword}
        onClickEditSecondPassword={onClickEditSecondPassword} />
      <MainAccountLinkoPayCard
        data={linkopay.data}
        businessRegistrationNumber={linkopay.businessRegistrationNumber}
        representativeName={linkopay.representativeName}
        email={linkopay.email}
        bankCode={linkopay.bankCode}
        bankName={linkopay.bankName}
        accountNumber={linkopay.accountNumber}
        settleCycle={linkopay.settleCycle}
        settleCycleUnit={linkopay.settleCycleUnit}
        onClickApply={onClickLinkoPayApply}
        onClickModify={onClickLinkoPayModify} />
      {
        isPhoneModalOpen &&
        <MainPhoneEditModal
          phone={phone}
          phoneCountryCode={phoneCountryCode}
          onClickExit={() => setIsPhoneModalOpen(false)}
          onClickSave={onClickSavePhone} />
      }
      {
        isPasswordModalOpen &&
        <MainPasswordEditModal
          onClickExit={() => setIsPasswordModalOpen(false)}
          onClickSave={onClickSavePassword} />
      }
      {
        isSecondPasswordModalOpen &&
        <MainSecondPasswordEditModal
          onClickExit={() => setIsSecondPasswordModalOpen(false)}
          onClickSave={onClickSaveSecondPassword} />
      }
      {
        linkoPayModalMode !== null &&
        <LinkoPayApplyModal
          mode={linkoPayModalMode}
          linkopayData={linkopay.data}
          businessRegistrationNumber={linkopay.businessRegistrationNumber}
          representativeName={linkopay.representativeName}
          linkopayEmail={linkopay.email}
          bankCode={linkopay.bankCode}
          bankName={linkopay.bankName}
          accountNumber={linkopay.accountNumber}
          settleCycle={linkopay.settleCycle}
          settleCycleUnit={linkopay.settleCycleUnit}
          storeName={linkopay.storeName}
          businessLicenseUrl={linkopay.businessLicenseUrl}
          businessLicenseFileName={linkopay.businessLicenseFileName}
          phone={linkopay.phone}
          countryCode={linkopay.countryCode}
          holderName={linkopay.holderName}
          onClickExit={() => setLinkoPayModalMode(null)}
          onClickSubmit={onClickLinkoPayApplySubmit} />
      }
    </TopLevelWrapper>
  );
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: stretch;

  gap: 20px;

  width: 100%;
`;
